exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-logged-out {\n  text-align: center;\n  padding: 30px 60px;\n}\n.modal-logged-out h3 {\n  margin: 30px 0;\n}\n.modal-logged-out p {\n  margin-bottom: 30px;\n}\n.modal-logged-out .glyphicon-hourglass {\n  display: block;\n  top: -83px;\n  left: 2px;\n  height: 0;\n  font-size: 62px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/authentication/loggedOut.modal.less
// module id = 2040
// module chunks = 0